// Playful sound effects for the intro animation using Web Audio API
let audioCtx = null;

function getCtx() {
  if (!audioCtx && typeof window !== 'undefined') {
    try {
      audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    } catch (e) { /* audio not supported */ }
  }
  return audioCtx;
}

function playTone(freq, duration, type = 'sine', volume = 0.15, delay = 0) {
  const ctx = getCtx();
  if (!ctx || ctx.state === 'suspended') return;
  const t = ctx.currentTime + delay;
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, t);
  gain.gain.setValueAtTime(0, t);
  gain.gain.linearRampToValueAtTime(volume, t + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.001, t + duration);
  osc.connect(gain);
  gain.connect(ctx.destination);
  osc.start(t);
  osc.stop(t + duration);
}

// Magical chime — logo appears
export function playLogoChime() {
  if (!getCtx()) return;
  [523, 659, 784, 1047].forEach((f, i) => playTone(f, 0.4, 'sine', 0.12, i * 0.08));
  playTone(1568, 0.6, 'sine', 0.06, 0.35);
  playTone(2093, 0.5, 'sine', 0.04, 0.45);
}

// Pop sound — letters & numbers fly out
export function playPop(pitch = 1) {
  if (!getCtx()) return;
  playTone(400 * pitch, 0.12, 'sine', 0.1, 0);
  playTone(600 * pitch, 0.08, 'sine', 0.06, 0.03);
}

// Twinkle — sparkle stars
export function playTwinkle() {
  if (!getCtx()) return;
  playTone(2400, 0.15, 'sine', 0.05, 0);
  playTone(3200, 0.12, 'sine', 0.04, 0.06);
  playTone(2800, 0.1, 'sine', 0.03, 0.12);
}

// Whoosh — rainbow sweep
export function playRainbowWhoosh() {
  const ctx = getCtx();
  if (!ctx || ctx.state === 'suspended') return;
  const t = ctx.currentTime;
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  const filter = ctx.createBiquadFilter();
  osc.type = 'sawtooth';
  osc.frequency.setValueAtTime(100, t);
  osc.frequency.exponentialRampToValueAtTime(800, t + 1.2);
  filter.type = 'lowpass';
  filter.frequency.setValueAtTime(200, t);
  filter.frequency.exponentialRampToValueAtTime(3000, t + 1.0);
  filter.frequency.exponentialRampToValueAtTime(200, t + 1.5);
  gain.gain.setValueAtTime(0, t);
  gain.gain.linearRampToValueAtTime(0.06, t + 0.3);
  gain.gain.linearRampToValueAtTime(0.04, t + 1.0);
  gain.gain.exponentialRampToValueAtTime(0.001, t + 1.5);
  osc.connect(filter);
  filter.connect(gain);
  gain.connect(ctx.destination);
  osc.start(t);
  osc.stop(t + 1.6);
}

// Sunshine warm tone
export function playSunshine() {
  if (!getCtx()) return;
  [392, 494, 587].forEach((f, i) => playTone(f, 0.5, 'triangle', 0.08, i * 0.12));
}

// Shape bounce — soft boing
export function playShapeBounce(pitch = 1) {
  const ctx = getCtx();
  if (!ctx || ctx.state === 'suspended') return;
  const t = ctx.currentTime;
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = 'sine';
  osc.frequency.setValueAtTime(600 * pitch, t);
  osc.frequency.exponentialRampToValueAtTime(200 * pitch, t + 0.15);
  gain.gain.setValueAtTime(0.08, t);
  gain.gain.exponentialRampToValueAtTime(0.001, t + 0.2);
  osc.connect(gain);
  gain.connect(ctx.destination);
  osc.start(t);
  osc.stop(t + 0.25);
}

// Subtitle reveal — gentle ascending notes
export function playSubtitleReveal() {
  if (!getCtx()) return;
  [330, 392, 494, 587, 659].forEach((f, i) => playTone(f, 0.35, 'sine', 0.06, i * 0.1));
}

// Resume audio context (needed for browsers that suspend it)
export function resumeAudio() {
  const ctx = getCtx();
  if (ctx && ctx.state === 'suspended') {
    ctx.resume();
  }
}
